import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';
import type { Role } from '@src/domain/rbac/entities/role.entity';

/**
 * Get Role By ID Use Case
 * Retrieves a specific role by its ID
 */
export class GetRoleByIdUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(roleId: string): Promise<Role | null> {
        return await this.roleRepository.getById(roleId);
    }
}
